import { RoleType, researcherWithRelatedBiobankSteeringGroupRole } from '../types/Role.types';

export const isUserResearcherWithRelatedBiobankSteeringGroup = (userRoles: RoleType[]) => {
  const typedRolesList = researcherWithRelatedBiobankSteeringGroupRole as readonly string[];
  return userRoles.every((role) => typedRolesList.includes(role));
};
